import _ from 'lodash';

export interface IGetterResult<T> {
    value: T;
}

export function createGetter<T>(getter: () => T, currentCacheId: () => string): IGetterResult<T> {
    let cache: T | undefined;
    let cacheId: string;

    return {
        get value(): T {
            if (cacheId === currentCacheId()) {
                return cache;
            }
            const value = getter();
            cacheId = currentCacheId();
            if (!_.isEqual(cache, value)) {
                cache = value;
            }

            return cache;
        }
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isDeepEqual(a: any, b: any): boolean {
    if (a != null && b != null) {
        if (typeof a === 'object' && typeof b === 'object') {
            return Object.keys(a).length === Object.keys(b).length &&
                Object.keys(a).every((k) => isDeepEqual(a[k], b[k]));
        } else if (Array.isArray(a) && Array.isArray(b)) {
            return a.length === b.length && a.every((v, i) => isDeepEqual(v, b[i]));
        }
        return a === b;
    }
    return a === b;
}

export function createSnapshot(obj: unknown, targetFields: string[]): Record<string, unknown> {
    try {
        const plainObj = targetFields?.length ? _.pick(obj, ...targetFields) : obj;
        return JSON.parse(JSON.stringify(plainObj));
    } catch (ex) {
        return undefined;
    }
}
